import { render, staticRenderFns } from "./CartAddressSelector.vue?vue&type=template&id=5f72323a&scoped=true&"
import script from "./CartAddressSelector.vue?vue&type=script&lang=js&"
export * from "./CartAddressSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72323a",
  null
  
)

export default component.exports